(function () {
  'use strict';
  if (window.MWStorefrontTestimonials) { window.MWStorefrontTestimonials.boot(); return; }
  const ALIAS = /^[a-z0-9][a-z0-9:._-]{0,199}$/i;
  const PRODUCT_GID = /^gid:\/\/shopify\/Product\/[1-9][0-9]*$/;
  const contexts = new WeakMap();
  let serial = 0;
  const uniqueQuotes = quotes => {
    const seen = new Set();
    return quotes.filter(quote => { if (seen.has(quote.id)) return false; seen.add(quote.id); return true; });
  };
  function resolveData({ content = null, productGid = '', topicIds = [], gallery = false }) {
    if (!content) throw new Error('Published testimonial content is unavailable.');
    if (gallery || productGid) {
      if (!gallery && !PRODUCT_GID.test(productGid)) throw new Error('Invalid testimonial product destination.');
      const selection = gallery ? content.gallery('artists') : content.productQuotes(productGid);
      if (!selection?.managed) return { managed: false, collections: [], quotes: [] };
      return { managed: true, collections: selection.collections, quotes: uniqueQuotes(selection.quotes) };
    }
    const seen = new Set();
    const collections = topicIds.flatMap(alias => {
      if (!ALIAS.test(alias || '')) return [];
      const collection = content.quoteCollection(alias);
      if (!collection || seen.has(collection.id)) return [];
      seen.add(collection.id); return [collection];
    });
    return { managed: true, collections, quotes: uniqueQuotes(collections.flatMap(collection => collection.quotes)) };
  }

  const arrow = direction => `<svg viewBox="0 0 24 24" fill="none"><path d="${direction === 'prev' ? 'M15 18L9 12L15 6' : 'M9 18L15 12L9 6'}" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  const nav = (direction, mobile = false) => `<button class="nav-button ${direction} ${mobile ? 'testimonial-mobile-nav' : 'desktop-nav'}" aria-label="${direction === 'prev' ? 'Previous' : 'Next'} testimonial">${arrow(direction)}</button>`;
  const profileImage = quote => quote.image ? `<img src="${quote.image}" alt="${quote.name}" class="profile-image">` : '';
  function productMarkup(quotes) {
    return quotes.map((quote, index) => `<div class="testimonial-slide ${index === 0 ? 'active' : ''}"><div class="testimonial-content">
      ${nav('prev')}<div class="content-wrapper"><div class="image-container desktop-image">${profileImage(quote)}</div>
      <div class="nav-image-group">${nav('prev', true)}<div class="image-container mobile-image">${profileImage(quote)}</div>${nav('next', true)}</div>
      <div class="quote-content"><div class="quote-mark"></div><p class="quote-text">${quote.quoteHtml}</p>
      <div class="author-info"><h3 class="author-name">${quote.name}</h3><p class="author-credits">${quote.credits}</p>
      ${quote.readMoreHref ? `<a href="${quote.readMoreHref}" class="read-more">read more testimonials</a>` : ''}</div></div></div>${nav('next')}</div></div>`).join('');
  }
  function renderProduct(root, data, context) {
    const quotes = [...data.quotes];
    if (root.dataset.randomize === 'true') for (let index = quotes.length - 1; index > 0; index--) {
      const other = Math.floor(Math.random() * (index + 1)); [quotes[index], quotes[other]] = [quotes[other], quotes[index]];
    }
    const slider = root.querySelector('.testimonial-slider');
    slider.innerHTML = productMarkup(quotes);
    if (!quotes.length) { root.hidden = true; return; }
    root.hidden = false;
    const slides = [...slider.querySelectorAll('.testimonial-slide')];
    let current = 0;
    const height = () => { const content = slides[current]?.querySelector('.testimonial-content'); if (content) slider.style.height = `${content.offsetHeight}px`; };
    const show = index => { current = (index + slides.length) % slides.length; slides.forEach((slide, index) => slide.classList.toggle('active', index === current)); height(); };
    const signal = context.abort.signal;
    slider.addEventListener('click', event => { const button = event.target.closest('.nav-button'); if (button && slider.contains(button)) show(current + (button.classList.contains('prev') ? -1 : 1)); }, { signal });
    let start = null;
    slider.addEventListener('touchstart', event => { start = event.changedTouches[0]?.clientX ?? null; }, { passive: true, signal });
    slider.addEventListener('touchend', event => { const end = event.changedTouches[0]?.clientX; if (start !== null && Number.isFinite(end) && Math.abs(end - start) >= 40) show(current + (end < start ? 1 : -1)); start = null; }, { passive: true, signal });
    window.addEventListener('resize', height, { signal });
    slider.querySelectorAll('img').forEach(image => image.addEventListener('load', height, { signal }));
    height();
  }

  function cardMarkup(quotes) {
    const first = quotes[0], multi = quotes.length > 1;
    const slides = quotes.map((quote, index) => `<div class="quote-slide ${index === 0 ? 'active' : ''}" data-index="${index}" data-product-name="${quote.productName}"><div class="quote">${quote.quoteHtml}</div></div>`).join('');
    const dots = multi ? `<div class="slide-dots">${quotes.map((_, index) => `<span class="dot ${index === 0 ? 'active' : ''}" data-slide="${index}" role="button" tabindex="0" aria-label="Show testimonial ${index + 1}"></span>`).join('')}</div>` : '';
    const logos = quotes.map((quote, index) => quote.productLogo ? `<a href="/products/${quote.productURL}" class="slide-logo ${index === 0 ? 'active' : ''}" data-logo="${index}"><img src="${quote.productLogo}" alt="MixWave: ${quote.productName}" width="75"></a>` : '').join('');
    return `<article class="testimonial-card ${multi ? 'is-slideshow' : ''}"><div class="profile"><div class="profile-img-wrapper">
      ${first.image ? `<img src="${first.image}" alt="${first.name}" class="profile-img">` : ''}${logos || dots ? `<div class="logo-overlay">${logos}${dots}</div>` : ''}</div>
      <div class="profile-info"><h3>${first.name}</h3><p class="collaborations">${first.credits}</p></div></div><div class="quote-slides">${slides}</div></article>`;
  }

  function renderGallery(root, data, context) {
    const container = root.querySelector('.testimonials-container');
    const productSelect = root.querySelector('[data-testimonial-product]');
    const artistSelect = root.querySelector('[data-testimonial-artist]');
    const search = root.querySelector('[data-testimonial-search]');
    if (!data.quotes.length) { container.replaceChildren(); root.hidden = true; return; }
    root.hidden = false;
    const byArtist = new Map();
    for (const quote of data.quotes) { if (!byArtist.has(quote.artistId)) byArtist.set(quote.artistId, []); byArtist.get(quote.artistId).push(quote); }
    const grids = new Map(), aliases = new Map([['all', 'all']]);
    container.replaceChildren(); productSelect.replaceChildren(new Option('All Products', 'all'));
    const addGrid = (key, gridId, cards) => {
      const grid = document.createElement('div'); grid.className = 'testimonials-grid'; grid.dataset.product = key;
      grid.id = document.getElementById(gridId) ? `${root.id}-${gridId}` : gridId;
      grid.innerHTML = cards; container.appendChild(grid); grids.set(key, grid); return grid;
    };
    addGrid('all', 'allGrid', [...byArtist.values()].map(cardMarkup).join(''));
    for (const collection of data.collections) {
      addGrid(collection.filterId, collection.gridId, collection.quotes.map(quote => cardMarkup([quote])).join(''));
      productSelect.add(new Option(collection.plain.title, collection.filterId));
      for (const alias of [collection.id, collection.filterId, collection.gridId, ...collection.anchorAliases, ...collection.legacyAliases]) aliases.set(alias, collection.filterId);
    }
    const signal = context.abort.signal;
    let active = grids.get('all');
    const activateSlide = (card, index) => {
      const quotes = card.querySelector('.quote-slides');
      if (quotes?.clientWidth) quotes.scrollTo({ left: index * quotes.clientWidth, behavior: 'smooth' });
      card.querySelectorAll('.dot, .slide-logo').forEach(element => element.classList.toggle('active', Number(element.dataset.slide ?? element.dataset.logo) === index));
    };
    const dots = event => { const dot = event.target.closest('.dot'); if (dot && container.contains(dot)) activateSlide(dot.closest('.testimonial-card'), Number(dot.dataset.slide)); };
    container.addEventListener('click', dots, { signal });
    container.addEventListener('keydown', event => { if (['Enter', ' '].includes(event.key) && event.target.matches('.dot')) { event.preventDefault(); dots(event); } }, { signal });
    container.querySelectorAll('.is-slideshow .quote-slides').forEach(element => {
      element.addEventListener('scroll', () => {
        if (!element.clientWidth) return;
        const card = element.closest('.testimonial-card');
        const index = Math.round(element.scrollLeft / element.clientWidth);
        card.querySelectorAll('.dot').forEach(dot => dot.classList.toggle('active', Number(dot.dataset.slide) === index));
        if (element._mwLogoTimer) clearTimeout(element._mwLogoTimer);
        element._mwLogoTimer = setTimeout(() => {
          if (signal.aborted || !element.clientWidth) return;
          const settled = Math.round(element.scrollLeft / element.clientWidth);
          card.querySelectorAll('.slide-logo').forEach(logo => logo.classList.toggle('active', Number(logo.dataset.logo) === settled));
        }, 150);
      }, { passive: true, signal });
    });
    container.querySelectorAll('.is-slideshow .profile-img-wrapper').forEach(image => {
      let start = null;
      image.addEventListener('touchstart', event => { start = event.touches[0]?.clientX ?? null; }, { passive: true, signal });
      image.addEventListener('touchend', event => {
        const end = event.changedTouches[0]?.clientX, card = image.closest('.testimonial-card'), quotes = card.querySelector('.quote-slides');
        if (start !== null && Number.isFinite(end) && Math.abs(end - start) >= 30 && quotes?.clientWidth) {
          const current = Math.round(quotes.scrollLeft / quotes.clientWidth), total = card.querySelectorAll('.quote-slide').length;
          activateSlide(card, Math.max(0, Math.min(total - 1, current + (end < start ? 1 : -1))));
        }
        start = null;
      }, { passive: true, signal });
    });
    const filter = () => {
      const query = search.value.trim().toLowerCase(), artist = artistSelect.value;
      active.querySelectorAll('.testimonial-card').forEach(card => {
        const name = card.querySelector('h3')?.textContent.trim() || '';
        const profile = card.querySelector('.profile-info')?.textContent.toLowerCase() || '';
        const slides = [...card.querySelectorAll('.quote-slide')];
        const match = slides.findIndex(slide => `${slide.textContent} ${slide.dataset.productName}`.toLowerCase().includes(query));
        const textMatch = !query || profile.includes(query) || match >= 0;
        card.style.display = textMatch && (artist === 'all' || name === artist) ? '' : 'none';
        if (slides.length > 1 && textMatch) activateSlide(card, query && !profile.includes(query) && match >= 0 ? match : 0);
      });
    };
    const switchProduct = () => {
      let hash; try { hash = decodeURIComponent(window.location.hash.slice(1)); } catch { hash = ''; }
      const key = aliases.get(hash) || 'all'; active = grids.get(key) || grids.get('all');
      for (const grid of grids.values()) grid.classList.toggle('active', grid === active);
      productSelect.value = key;
      const names = [...new Set([...active.querySelectorAll('h3')].map(element => element.textContent.trim()))].sort();
      artistSelect.replaceChildren(new Option('All Artists', 'all'), ...names.map(name => new Option(name, name)));
      filter();
    };
    productSelect.addEventListener('change', () => { window.location.hash = productSelect.value; switchProduct(); }, { signal });
    artistSelect.addEventListener('change', filter, { signal }); search.addEventListener('input', filter, { signal });
    window.addEventListener('hashchange', switchProduct, { signal }); switchProduct();
  }

  function clear(root) {
    root.hidden = true;
    const container = root.querySelector(root.dataset.mwTestimonials === 'gallery' ? '.testimonials-container' : '.testimonial-slider');
    if (container) container.innerHTML = '';
  }
  async function initialize(root) {
    if (contexts.has(root)) return;
    const context = { abort: new AbortController() }; contexts.set(root, context);
    if (!root.id) root.id = `mw-testimonials-${++serial}`;
    root.dataset.contentState = 'loading';
    clear(root);
    try {
      const reader = window.MWStorefrontContent;
      if (!reader) throw new Error('The published-content reader is required.');
      const content = await reader.ready;
      if (context.abort.signal.aborted) return;
      const gallery = root.dataset.mwTestimonials === 'gallery';
      const productGid = root.dataset.productGid || '';
      const data = resolveData({ content, productGid, topicIds: (root.dataset.topicIds || '').split(',').map(value => value.trim()).filter(Boolean), gallery });
      root.dataset.contentState = data.managed ? 'managed' : 'unassigned';
      if (gallery) renderGallery(root, data, context); else renderProduct(root, data, context);
    } catch (error) {
      if (context.abort.signal.aborted) return;
      clear(root); root.dataset.contentState = 'error';
      window.console?.warn('MixWave testimonials could not be loaded.', error);
    }
  }
  function boot(scope = document) { scope.querySelectorAll('[data-mw-testimonials]').forEach(initialize); }
  function refresh(error = false) {
    document.querySelectorAll('[data-mw-testimonials]').forEach(root => {
      contexts.get(root)?.abort.abort(); contexts.delete(root); clear(root);
      if (error) root.dataset.contentState = 'error'; else initialize(root);
    });
  }
  window.MWStorefrontTestimonials = Object.freeze({ resolveData, productMarkup, cardMarkup, boot });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true }); else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-mw-testimonials]').forEach(root => { contexts.get(root)?.abort.abort(); contexts.delete(root); }));
  document.addEventListener('mw:content-ready', () => refresh());
  document.addEventListener('mw:content-error', () => refresh(true));
})();
